import React from 'react'

import Tooltip2 from 'components/common/Tooltip2.0'

import { IconImg, Wrapper } from './styles'

const TeacherTileToggler = ({ isFullScreen, toggle }) => {
    const tooltipText = isFullScreen ? 'minimize' : 'maximize'

    const icon = isFullScreen ? 'fullscreen-reverse' : 'fullscreen'

    const imgProps = {
        alt: `${icon}-icon`,
        src: `/assets/revamp/${icon}.svg`,
    }

    return (
        <Wrapper onClick={toggle}>
            <Tooltip2 content={tooltipText} placement="bottom">
                <IconImg {...imgProps} />
            </Tooltip2>
        </Wrapper>
    )
}

export default TeacherTileToggler
